import React, {Component, useMemo} from 'react';
import {withStyles} from "@material-ui/styles";
import {FormControl, MenuItem, TextField} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import FieldWrapper from "../FieldWrapper";
import findByString from "../Utils/getValueByString";
import request from "../../../../Services/API/Requests";
import listRequestWrapper from "../../../../Services/API/listRequestWrapper";
import {errorHandler} from "../Utils/errorHandler";
import FieldErrorMessage from "../Utils/errorMessage";
import CustomFrequency from "./FrequencyType/CustomFrequencyInput";
import clsx from "clsx";
import {setArrayPath} from "../Utils/setArrayPath";
import {multiLanguageValue} from "../../../../Components/JsonScreen/Utils/lib";

const styles = () => ({
    formControl: {width: '100%'}
});

class Frequency extends Component {
    constructor(props) {
        super(props);
        this.fieldRef = React.createRef();
        this.state = {
            values: {},
            checked: 'none',
            initialValue: {},
            fieldValue: {},
            customValues: {},
            frequencyList: [],
            daysOfWeek: [],
            isCustomFrequencyOpen: false,
            errorComponent: false,
            error: '',
            path: ''
        }
    }

    componentDidMount = async () => {
        const {onBlurFromCell, field, focusNow} = this.props;
        this.initValues();
        if (focusNow && field.disabled) {
            onBlurFromCell();
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {values, errors} = this.props;
        const {values: prevValues, errors: prevErrors} = prevProps;
        if (JSON.stringify(values) !== JSON.stringify(prevValues)) {
            this.setValues();
        }
        if (errors !== prevErrors) {
            this.setErrors();
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({errorComponent: true});
        console.log(error, errorInfo)
    }

    initValues = async () => {
        const {values, field: {allowedFrequencyTypes}} = this.props;
        const frequencyListRemote = await listRequestWrapper('frequencyType');
        const daysOfWeek = await listRequestWrapper('dayOfWeek');
        this.setState({
            values,
            frequencyTypeList: frequencyListRemote.filter((item) => item.name !== 'Custom...').filter(item => {
                if (allowedFrequencyTypes && allowedFrequencyTypes.length) {
                    return allowedFrequencyTypes.includes(item.id)
                }
                return true
            }),
            daysOfWeek: daysOfWeek,
        })
        this.setValues();
    }

    setValues = async () => {
        const {values, field: {path}, containerArrayPath} = this.props;
        try {
            let arrayPath = setArrayPath(path, containerArrayPath);
            const frequencyListRemote = this.state.frequencyList.length ?
                this.state.frequencyList : await listRequestWrapper('frequencyType');

            let frequencyListWithDefault = this.state.frequencyList.length ?
                this.state.frequencyList : this.insertDefaultValues(frequencyListRemote);
            const currentValue = findByString(values, arrayPath ? arrayPath : path);
            let value = await this.frequencyToText(currentValue, frequencyListWithDefault);
            const frequencyListWithCustom = newFrequencyList(value, frequencyListWithDefault)
            this.setState({values, fieldValue: value, frequencyList: frequencyListWithCustom})
        } catch (e) {
            console.log(e)
        }
    };
    setErrors = () => {
        const {errors, field: {path}, containerArrayPath} = this.props;
        let errorField = errorHandler(errors, path, containerArrayPath);
        this.setState({error: errorField})
    };

    insertDefaultValues(values = []) {
        let newValues = [];
        const {field: {allowedFrequencyTypes}} = this.props;
        values.filter((item) => item.name !== 'Custom...').forEach((element) => {

            //FILTER BY ALLOWED FREQUENCY TYPE (FROM FIELD PROPERTIES)
            if (allowedFrequencyTypes && allowedFrequencyTypes.length) {
                if (allowedFrequencyTypes.includes(element.id)) {
                    newValues.push({
                        type: element,
                        every: 1,
                        text: multiLanguageValue(element.name, 'en')
                    });
                }
                return
            }

            newValues.push({
                type: element,
                every: 1,
                text: multiLanguageValue(element.name, 'en')
            })
        });
        return newValues;
    };


    //input handlers
    onChangeFrequency = (event) => {
        const {setValue, field: {path, trackChange}, containerArrayPath} = this.props;
        const {frequencyList} = this.state;
        const {target: {value}} = event;
        let arrayPath = setArrayPath(path, containerArrayPath);
        if (value !== undefined) {
            //find from list object by text
            const objectValue = frequencyList.find(f => f.text === value)

            this.setState({fieldValue: objectValue});

            setValue(objectValue, arrayPath ? arrayPath : path, trackChange)
        }
    };
    onBlur = () => {
        const {fieldValue} = this.state;
        const {setValue, field: {path, trackChange}, focusNow, onBlurFromCell} = this.props;
        setValue(fieldValue, path, trackChange);
        if (focusNow) {
            onBlurFromCell();
        }

    };
    onClickItem = () => {
        this.setState(state => ({
            ...state,
            isCustomFrequencyOpen: true,
            checked: this.setChecked(state.fieldValue),
            customValues: {
                every: state.fieldValue.every || '',
                type: state.fieldValue.type || {},
                start: state.fieldValue.start || '',
                endsOn: state.fieldValue.endsOn,
                dayOfWeek: state.fieldValue.dayOfWeek || null,
                dayOfMonth: state.fieldValue.dayOfMonth || '',
                maxIterations: state.fieldValue.maxIterations || null,
                time: state.fieldValue.time || null,
                nextRunTime: state.fieldValue.nextRunTime || null,
                lastTimeRan: state.fieldValue.lastTimeRan || null,
            }
        }))
    };
    onKeyDownItem = (e) => {
        if (e.key === 'Enter') {
            this.onClickItem();
        }
    };
    closeCustom = () => {
        this.setState({isCustomFrequencyOpen: false})
    };
    onCompleteFrequency = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const {customValues, frequencyList} = this.state;
        this.checkForChecked();
        const newValue = await this.frequencyToText(customValues, frequencyList);
        this.setState(() => ({
            fieldValue: newValue,
            customValues: {},
            isCustomFrequencyOpen: false,
            frequencyList: newFrequencyList(newValue, frequencyList)
        }), () => {
            this.onBlur();
        });
    };

    //custom frequency input handlers
    onChangeEvery = (event) => {
        const {target: {value}} = event;
        this.setState(state => ({
            customValues: {...state.customValues, every: value}
        }))
    };
    onChangeType = (event, value) => {
        this.setState(state => ({
            customValues: {...state.customValues, type: value ? value : {}}
        }))
    };
    onChangeTypeDays = (event, value) => {
        const {customValues: {dayOfWeek}} = this.state;
        let daysOfWeek = dayOfWeek ? Array.isArray(dayOfWeek) ? dayOfWeek.slice() : [dayOfWeek] : [];
        let index = daysOfWeek.findIndex(v => v._id === value._id)
        if (index > -1) {
            // Remove the existing value
            daysOfWeek.splice(index, 1);
        } else if (value) {
            // Add new value
            daysOfWeek.push(value);
        }
        this.setState(state => ({
            customValues: {
                ...state.customValues,
                dayOfWeek: daysOfWeek
            }
        }))
    };
    onChangeCustomFields = (event) => {
        const {target: {value, name}} = event;
        this.setState(state => ({customValues: {...state.customValues, [name]: value}}), () => {
            if (name === 'start') {
                this.setState(state => ({
                    customValues: {
                        ...state.customValues,
                        nextRunTime: undefined,
                        lastTimeRan: undefined
                    }
                }))
            }
        })
    };
    onChangeRadio = (event) => {
        const {target: {value}} = event;
        this.setState({checked: value});
    };
    checkForChecked = () => {
        const {checked, customValues} = this.state;
        if (checked === 'on') {
            if (customValues.maxIterations) {
                delete customValues.maxIterations;
            }
        } else if (checked === 'after') {
            if (customValues.endsOn) {
                delete customValues.endsOn;
            }
        } else if (checked === 'none') {
            if (customValues.endsOn) {
                delete customValues.endsOn;
            }
            if (customValues.maxIterations) {
                delete customValues.maxIterations
            }
        }
    };
    setChecked = (value = {}) => {
        if (value.endsOn) {
            return 'on'
        } else if (value.maxIterations) {
            return 'after'
        } else {
            return 'none'
        }
    };


    frequencyToText = async (value, frequencyList) => {
        if (value) {
            try {
                const res = await request({
                    url: '/core/frequencyToText',
                    method: 'POST',
                    data: value
                });
                const isCustom = frequencyList.find(f => f.text === res.text);
                return {...res, custom: !Boolean(isCustom)}
            } catch (e) {
                console.log(e)
                return {};
            }
        } else {
            return {};
        }
    };


    render() {
        const {
            classes,
            field: {
                disabled, path, label, required,
                autofocus, timeRequired
            },
            fieldStyles, labelStyles, showLabel, goBack,
            focusNow, isMobile, globalValues, screenName
        } = this.props;
        const {
            frequencyList, frequencyTypeList, fieldValue, customValues,
            isCustomFrequencyOpen, daysOfWeek, checked, errorComponent, error
        } = this.state;

        return (
            !errorComponent ? (
                <FieldWrapper
                    path={path}
                    disabled={disabled}
                    setValue={this.onChangeFromDropDown}
                    fieldRef={this.fieldRef}
                    fieldStyles={fieldStyles}
                    labelStyles={labelStyles}
                    showLabel={showLabel}
                    focusNow={focusNow}
                    label={label}
                    goBack={goBack}
                    required={required}
                    isMobile={isMobile}
                    globalValues={globalValues}
                    screenName={screenName}
                >
                    <FormControl classes={{root: classes.formControl}}
                                 fullWidth={isMobile ? true : fieldStyles.fullWidth}
                                 style={{width: fieldStyles.fullWidth ? '100%' : fieldStyles.width}}
                    >
                        <FrequencyInput
                            fieldStyles={fieldStyles}
                            focusNow={focusNow}
                            autofocus={autofocus}
                            fieldRef={this.fieldRef}
                            frequencyList={frequencyList}
                            fieldValue={fieldValue}
                            required={required}
                            onChangeFrequency={this.onChangeFrequency}
                            onBlur={this.onBlur}
                            onKeyDownItem={this.onKeyDownItem}
                            onClickItem={this.onClickItem}
                            error={error}
                            label={label}
                            isMobile={isMobile}
                            path={path}
                        />
                        <FieldErrorMessage message={error}/>
                    </FormControl>
                    <CustomFrequency
                        isCustomFrequencyOpen={isCustomFrequencyOpen}
                        closeCustom={this.closeCustom}
                        onCompleteFrequency={this.onCompleteFrequency}
                        values={customValues}
                        onChangeEvery={this.onChangeEvery}
                        onChangeType={this.onChangeType}
                        onChangeTypeDays={this.onChangeTypeDays}
                        onChangeCustomFields={this.onChangeCustomFields}
                        onChangeRadio={this.onChangeRadio}
                        frequencyTypeList={frequencyTypeList}
                        daysOfWeek={daysOfWeek}
                        checked={checked}
                        timeRequired={timeRequired}
                    />
                </FieldWrapper>
            ) : (
                <span>Something bad with field</span>
            )
        );
    }
}


export default withStyles(styles)(Frequency);


const FrequencyInput = (props) => {
    const {fieldValue, path} = props;
    const inputValue = useMemo(() => {
        if (typeof fieldValue === 'object' && fieldValue.hasOwnProperty('text')) {
            return fieldValue.text
        }
        return '';
    }, [JSON.stringify(fieldValue)])
    return (
        <TextField
            fullWidth={props.isMobile ? true : props.fieldStyles.fullWidth}
            error={props.error.length > 0}
            select
            autoFocus={!!(props.focusNow || props.autofocus)}
            onBlur={props.onBlur}
            required={props.required}
            label={props.isMobile && props.label}
            variant={props.isMobile ? 'standard' : "outlined"}
            value={inputValue}
            name={path}
            onChange={props.onChangeFrequency}
            className={clsx("sb-field", props.fieldStyles.withoutStyles ? 'horizontal-fields-table-frequency' : 'form-dynamic-frequency')}
            style={{
                flex: '1 1 auto',
                display: 'block',
                outline: '1px',
                height: !props.isMobile && 25,
                paddingTop: !props.isMobile && 3,
                paddingLeft: !props.isMobile && 2,
            }}
            //  inputRef={props.fieldRef}
            SelectProps={{
                className: props.fieldStyles.withoutStyles ? 'horizontal-fields-table-frequency' : 'form-dynamic-frequency',
                style: {
                    width: '100%',
                    height: props.fieldStyles.height
                },
            }}
        >
            {props.frequencyList.map((element, index) => {
                return (
                    <MenuItem key={index} style={{paddingTop: 2, paddingBottom: 2}} value={element.text}>
                        {element.text}
                    </MenuItem>
                )
            })}
            <ListItem style={{height: 28}} button={true}
                      onClick={(e) => e.preventDefault()}
                      onKeyDown={props.onKeyDownItem}
            >
                <ListItemText style={{paddingLeft: 0}} inset primary="Custom..."
                              onClick={props.onClickItem}
                />
            </ListItem>
        </TextField>
    )
};

const newFrequencyList = (newValue, frequencyList) => {
    if (newValue.custom) {
        const listCopy = JSON.parse(JSON.stringify(frequencyList));
        const indexOfCustomValue = frequencyList.findIndex(f => f.custom)
        if (indexOfCustomValue !== -1) {
            listCopy[indexOfCustomValue] = newValue;
            return listCopy;
        }
        listCopy.push(newValue);
        return listCopy
    }
    return frequencyList
}